var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"ripple"}},[(_vm.show)?_c('div',{staticClass:"mu-circle-ripple",style:(_vm.styles)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }